<template>
  <div>
    <div
      v-for="item in items"
      :key="item"
      class="d-flex align-center py-6px"
    >
      <tm-skeleton
        class="mr-2"
        type="QChip"
        :width="item"
        height="8px"
      />
      <tm-skeleton
        type="QChip"
        width="14px"
        height="8px"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'

export default defineComponent({
  components: { TmSkeleton },
  setup() {
    return {
      items: ['38%', '58%', '35%', '27%', '44%'],
    }
  },
})
</script>

<style lang="scss" scoped>
.py-6px {
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>
